import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import {
  ITimeRegistration,
  IProject,
} from "../model/top.model";

import { TimeRegistrationType } from "../enums/enums";
import { AuthService } from './auth/auth.service';
import { ENV } from '@app/env';

@Injectable()
export class TimeRegistrationData {
  timeRegistrations: Array<ITimeRegistration> = [];
  apiUrl: string = ENV.apiUrl;

  constructor(
    public http: HttpClient,
    public storage: Storage,
    private authService: AuthService
  ) { }

  download(week, year, type, oneWeek) {
    this.authService.getAuthorizationToken().then((token) => {
      let url =  this.apiUrl +
      "download/index.php?year=" +
      year +
      "&week=" +
      week +
      "&type=" +
      type +
      "&logintype=user" +
      "&token=" +
      token;
      if (oneWeek) {
        url += "&oneweek=true";
      }
      var newWin = window.open(
        url,
        "_system"
      );
      if (!newWin) {
        window.location.href =
        url;
      }
    });
  }

  process(week, year) {
    let timeRegistrationObject = {
      operation: "PROCESS",
      year: year,
      week: week,
    };
    return new Promise((resolve) => {
      this.http.post(
        this.apiUrl + "timeregistrations/",
        JSON.stringify(timeRegistrationObject)
      ).subscribe((response) => {
        resolve(response);
      }, (error) => {
        resolve(null);
      });
    });
  }

  getTimeRegistrations(year, week): Promise<Array<ITimeRegistration>> {
    let timeRegistrationObject = {
      operation: "ALL",
      year: year,
      week: week,
    };
    return new Promise((resolve) => {
      this.http.post<ITimeRegistration[]>(
        this.apiUrl + "timeregistrations/",
        JSON.stringify(timeRegistrationObject)
      ).subscribe((response) => {
        this.timeRegistrations = response;
        resolve(response);
      }, (error) => {
        resolve(null);
      });
    });
  }

  getEmployeeTimeRegistrations(
    employee_id,
    year,
    week
  ): Promise<Array<ITimeRegistration>> {
    let timeRegistrationObject = {
      operation: "TIMEREGISTRATIONS",
      employee_id: employee_id,
      year: year,
      week: week,
    };
    return new Promise((resolve) => {
      this.http.post<ITimeRegistration[]>(
        this.apiUrl + "employees/",
        JSON.stringify(timeRegistrationObject)
      ).subscribe((response) => {
        resolve(response);
      }, (error) => {
        resolve(null);
      });
    });
  }

  downloadProjectTimeRegistrations(project_id, project_name): void {
    this.authService.getAuthorizationToken().then((token) => {
      var newWin = window.open(
        this.apiUrl +
        "download/index.php?project_id=" +
        project_id +
        "&project_name=" +
        project_name +
        "&type=project&logintype=user" +
        "&token=" +
        token,
        "_system"
      );
      if (!newWin) {
        window.location.href =
          this.apiUrl +
          "download/index.php?project_id=" +
          project_id +
          "&project_name=" +
          project_name +
          "&type=project&logintype=user" +
          "&token=" +
          token;
      }
    });
  }

  createTimeRegistration(
    timeRegistration: ITimeRegistration
  ): Promise<ITimeRegistration> {
    timeRegistration.operation = "POST";
    return new Promise((resolve, reject) => {
      this.http.post(
        this.apiUrl + "timeregistrations/",
        JSON.stringify(timeRegistration)
      ).subscribe((response) => {
        timeRegistration.time_registration_id = response[0].time_registration_id;
        this.timeRegistrations.push(timeRegistration);
        resolve(timeRegistration);
      }, (error) => {
        reject(error);
      });
    });
  }

  getTimeRegistration(timeRegistrationId: string): Promise<ITimeRegistration> {
    let timeRegistrationObject = {
      operation: "GET",
      time_registration_id: timeRegistrationId,
    };
    return new Promise((resolve) => {
      this.http.post(this.apiUrl + "timeregistrations/",
        JSON.stringify(timeRegistrationObject)
      ).subscribe((response) => {
        resolve(response[0]);
      }, (error) => {
        resolve(null);
      });
    });
  }

  setTimeRegistration(timeRegistration: ITimeRegistration, day: string): Promise<boolean> {
    timeRegistration.operation = "PUT";
    timeRegistration.day = day;
    return new Promise((resolve, reject) => {
      this.http.post(
        this.apiUrl + "timeregistrations/",
        JSON.stringify(timeRegistration)
      ).subscribe((response) => {
        // search for timeRegistration and overwrite
        for (let timeRegistrationKey in this.timeRegistrations) {
          if (
            this.timeRegistrations[timeRegistrationKey]
              .time_registration_id === response[0].time_registration_id
          ) {
            this.timeRegistrations[timeRegistrationKey] = response[0];
            break;
          }
        }
        resolve(response[0]);
      }, (error) => {
        reject(error);
      });
    });
  }

  setTimeRegistrationStatus(timeRegistration: ITimeRegistration): Promise<boolean> {
    timeRegistration.operation = "PUT_STATUS";
    return new Promise((resolve, reject) => {
      this.http.post(
        this.apiUrl + "timeregistrations/",
        JSON.stringify(timeRegistration)
      ).subscribe((response) => {
        // search for timeRegistration and overwrite
        for (let timeRegistrationKey in this.timeRegistrations) {
          if (
            this.timeRegistrations[timeRegistrationKey]
              .time_registration_id === response[0].time_registration_id
          ) {
            this.timeRegistrations[timeRegistrationKey] = response[0];
            break;
          }
        }
        resolve(response[0]);
      }, (error) => {
        reject(error);
      });
    });
  }

  deleteTimeRegistration(
    timeRegistration: ITimeRegistration
  ): Promise<ITimeRegistration> {
    timeRegistration.operation = "DELETE";
    return new Promise((resolve) => {
      this.http.post(
        this.apiUrl + "timeregistrations/",
        JSON.stringify(timeRegistration)
      ).subscribe((response) => {
        let foundIndex = this.timeRegistrations.indexOf(timeRegistration);
        if (foundIndex > -1) {
          this.timeRegistrations.splice(foundIndex, 1);
        }
        resolve(response[0]);
      }, (error) => {
        resolve(null);
      });
    });
  }

  findTimeRegistrations(
    projectId: string,
    employeeId: string,
    year: number,
    week: number
  ): Promise<Array<ITimeRegistration>> {
    return new Promise((resolve) => {
      resolve(
        this.timeRegistrations.filter((timeRegistration) => {
          return (
            timeRegistration.project_id.indexOf(projectId) > -1 &&
            timeRegistration.employee_id.indexOf(employeeId) > -1 &&
            timeRegistration.year == year &&
            timeRegistration.week == week
          );
        })
      );
    });
  }

  findEmployeeTimeRegistrations(
    employeeId: string,
    all: boolean,
    year: number,
    week: number
  ): Promise<Array<ITimeRegistration>> {
    if (all) {
      return new Promise((resolve) => {
        this.getTimeRegistrations(null, null).then((timeRegistrations) => {
          resolve(
            timeRegistrations.filter((timeRegistration) => {
              return timeRegistration.employee_id.indexOf(employeeId) > -1;
            })
          );
        });
      });
    }
    return new Promise((resolve) => {
      this.getTimeRegistrations(null, null).then((timeRegistrations) => {
        resolve(
          this.timeRegistrations.filter((timeRegistration) => {
            return (
              timeRegistration.employee_id.indexOf(employeeId) > -1 &&
              timeRegistration.year == year &&
              timeRegistration.week == week
            );
          })
        );
      });
    });
  }

  findProjectTimeRegistrations(
    projectId: string
  ): Promise<Array<ITimeRegistration>> {
    return new Promise((resolve) => {
      this.getTimeRegistrations(null, null).then((timeRegistrations) => {
        resolve(
          timeRegistrations.filter((timeRegistration) => {
            return timeRegistration.project_id.indexOf(projectId) > -1;
          })
        );
      });
    });
  }

  getHoursForProject(project: IProject): number {
    let totalHours = 0;
    project.timeRegistrationsFiltered.forEach((timeRegistration) => {
      if (timeRegistration.type == TimeRegistrationType.Scholing) {
        // do nothing for scholing
      } else if (
        timeRegistration.type == TimeRegistrationType.OpbouwTijdVoorTijd
      ) {
        totalHours -= this.getHoursForTimeRegistration(timeRegistration);
      } else {
        totalHours += this.getHoursForTimeRegistration(timeRegistration);
      }
    });
    return totalHours;
  }

  getHoursForProjectDay(project: IProject, day: string): number {
    let totalHours = 0;
    project.timeRegistrationsFiltered.forEach((timeRegistration) => {
      if (timeRegistration.type == TimeRegistrationType.OpbouwTijdVoorTijd) {
        totalHours -= parseInt(timeRegistration[day].substr(0, 2));
        if (timeRegistration[day].charAt(3) === "3") {
          totalHours -= 0.5;
        }
      } else {
        totalHours += parseInt(timeRegistration[day].substr(0, 2));
        if (timeRegistration[day].charAt(3) === "3") {
          totalHours += 0.5;
        }
      }
    });
    return totalHours;
  }

  getHoursForTimeRegistration(timeRegistration: ITimeRegistration): number {
    let totalHours = 0;
    totalHours += parseInt(timeRegistration.mondayHHmm.substr(0, 2));
    if (timeRegistration.mondayHHmm.charAt(3) === "3") {
      totalHours += 0.5;
    }
    totalHours += parseInt(timeRegistration.tuesdayHHmm.substr(0, 2));
    if (timeRegistration.tuesdayHHmm.charAt(3) === "3") {
      totalHours += 0.5;
    }
    totalHours += parseInt(timeRegistration.wednesdayHHmm.substr(0, 2));
    if (timeRegistration.wednesdayHHmm.charAt(3) === "3") {
      totalHours += 0.5;
    }
    totalHours += parseInt(timeRegistration.thursdayHHmm.substr(0, 2));
    if (timeRegistration.thursdayHHmm.charAt(3) === "3") {
      totalHours += 0.5;
    }
    totalHours += parseInt(timeRegistration.fridayHHmm.substr(0, 2));
    if (timeRegistration.fridayHHmm.charAt(3) === "3") {
      totalHours += 0.5;
    }
    totalHours += parseInt(timeRegistration.saturdayHHmm.substr(0, 2));
    if (timeRegistration.saturdayHHmm.charAt(3) === "3") {
      totalHours += 0.5;
    }
    return totalHours;
  }

  /**
   * Helper method to make a unique clone of an object
   *
   */
  cloneObject(obj) {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.cloneObject(obj[i]);
      }
      return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = this.cloneObject(obj[attr]);
      }
      return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
  }
  /* For a given date, get the ISO week number
   * https://stackoverflow.com/questions/6117814/get-week-of-year-in-javascript-like-in-php/6117889#6117889
   *
   * Based on information at:
   *
   *    http://www.merlyn.demon.co.uk/weekcalc.htm#WNR
   *
   * Algorithm is to find nearest thursday, it's year
   * is the year of the week number. Then get weeks
   * between that date and the first day of that year.
   *
   * Note that dates in one year can be weeks of previous
   * or next year, overlap is up to 3 days.
   *
   * e.g. 2014/12/29 is Monday in week  1 of 2015
   *      2012/1/1   is Sunday in week 52 of 2011
   */
  getWeekNumber(date) {
    // Copy date so don't modify original
    let d = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    // Get first day of year
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    // Calculate full weeks to nearest Thursday
    let weekNo = Math.ceil(
      ((d.valueOf() - yearStart.valueOf()) / 86400000 + 1) / 7
    );
    // Return array of year and week number
    return [d.getUTCFullYear(), weekNo];
  }

  getWeeksInYear(year) {
    var week = this.getWeekNumber(new Date(year, 11, 31))[1];
    return week == 1 ? this.getWeekNumber(new Date(year, 11, 24))[1] : week;
  }

  getMondayOfWeekInYear(week, year): Date {
    if (typeof year === "undefined") {
      year = new Date().getFullYear();
    }
    if (week == 53 && this.getWeeksInYear(year) != 53) {
      week = 52;
    }
    var date = this.mondayOfFirstWeekOfYear(year);
    if (week > 1) {
      date.setDate(date.getDate() + (week - 1) * 7);
    }
    return date;
  }

  mondayOfFirstWeekOfYear(year): Date {
    var date = new Date(year, 0, 1);
    // date = this.firstDayOfYear(date, year);
    let day = date.getDay();
    day = day === 0 ? 7 : day;
    console.log(date, day);
    if (day >= 5) {
      date.setDate(date.getDate() + 8 - day);
    } else {
      date = this.mondayOfWeek(date);
    }
    return date;
  }

  mondayOfWeek(date): Date {
    let day = date.getDay();
    day = day === 0 ? 7 : day;
    if (day > 1) {
      date.setDate(date.getDate() - (day - 1));
    }
    return date;
  }
}



// WEBPACK FOOTER //
// ./src/providers/time-registration-data.ts